import SelectWidget from '../../../lib/SelectWidget/SelectWidget';
import {postAPICall} from '../../../services/apiCallsHandler';
import CurrentlyUnavailableCard from '../../currently_unavailable_div/CurrentlyUnavailableCard';
import SkeletonLoader from '../../skeletonLoader/SkeletonLoader';
import './BillingPeriodSelect.css';

import {Card, CardContent, Alert} from '@deere/fuel-react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';

const ERROR_TYPES = {
  TIMEOUT: 'TIMEOUT',
  SERVER: 'SERVER',
};

const ERROR_CONTENT = {
  [ERROR_TYPES.TIMEOUT]: {
    title: 'LEASE_INVOICE_TIMEOUT_TITLE',
    subTitle: 'LEASE_INVOICE_TIMEOUT_DESC',
  },
  [ERROR_TYPES.SERVER]: {
    title: 'SOMETHING_WENT_WRONG',
    subTitle: 'LEASE_INVOICE_NOT_AVAILABLE',
  },
};

const BillingPeriodSelect = (props) => {
  const {t} = useTranslation();
  const [selectedValue, setSelectedValue] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [periodOptions, setPeriodOptions] = React.useState([]);
  const [errorType, setErrorType] = React.useState(null);

  React.useEffect(() => {
    const selectedProductType = props.contracts?.find(
      (contract) => contract.contractNumber === props.selectedContractNumber
    )?.productLine;

    if (
      props.selectedContractNumber &&
      selectedProductType &&
      selectedProductType !== 'LOAN-INSTALLMENT'
    ) {
      setIsLoading(true);
      setErrorType(null);
      props.onTimeoutChange?.(false);
      props.on5xxChange?.(false);
      postAPICall(
        `leaseinvoice`,
        {
          requestType: 'Lease invoice',
          contractNumber: props.selectedContractNumber,
          countryCode: props.countryCode,
          ...(props.selectedOrg && {party: props.selectedOrg}),
        },
        {
          errorTag: 'FETCH_LEASE_INVOICE',
          redirectToOops: false,
        }
      ).then((res) => {
        setIsLoading(false);
        setSelectedValue(null);
        props.onDropdownChange(null);
        if (res?.status === 503) {
          setErrorType(ERROR_TYPES.TIMEOUT);
          setPeriodOptions([]);
          props.onTimeoutChange?.(true);
        } else if (res?.status >= 500) {
          setErrorType(ERROR_TYPES.SERVER);
          setPeriodOptions([]);
          props.on5xxChange?.(true);
        } else {
          setPeriodOptions(
            res?.body?.billingPeriods ? res.body.billingPeriods : []
          );
        }
      });
    }
  }, [props.selectedContractNumber]);

  const handleChange = (event) => {
    setSelectedValue(event);
    props.onDropdownChange(event);
  };

  return (
    <div className={'BillingPeriodSelectWrapper'}>
      {isLoading ? (
        <SkeletonLoader componentName="ServiceRequestDashboard" />
      ) : (
        <div>
          {errorType ? (
            <CurrentlyUnavailableCard
              title={t(ERROR_CONTENT[errorType].title)}
              subTitle={t(ERROR_CONTENT[errorType].subTitle)}
              fullScreen={true}
            />
          ) : (
            <>
              <div className="title">{t('LEASE_INVOICE')}</div>
              <div className={'raiseDownloadRequestSubTitle'}>
                {t('BILLING_PERIOD_DESC')}
              </div>
              <div className="leaseInvoiceAvailabilityInfo">
                <Alert
                  variant="info"
                  className="leaseInvoiceAvailabilityAlertInfo"
                >
                  {t('LEASE_INVOICE_AVAILABILITY_INFO')}
                </Alert>
              </div>
              <Card className="billingPeriodCard">
                <CardContent className="cardConentCustom ServiceRequestTypeField">
                  <div className="billingPeriodSelectClass">
                    <SelectWidget
                      id="billingPeriodSelect"
                      changeHandler={handleChange}
                      label={t('BILLING_PERIOD')}
                      data={periodOptions}
                      multiple={false}
                      hasSelectAll={false}
                      disabled={false}
                      value={selectedValue ?? ''}
                      required={true}
                    />
                  </div>
                </CardContent>
              </Card>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export const mapStateToProps = (state) => {
  return {
    contracts: state.appStates.contractNumbers?.contracts,
  };
};
export default connect(mapStateToProps)(BillingPeriodSelect);
